import {
  AdminMethods as DiscountFeederAdminMethods,
  SetDiscountForTier as discountFeederSetDiscountForTier,
  RemoveDiscount as discountFeederRemoveDiscount,
  ChangeOwner as discountFeederChangeOwner,
} from './admin';
import {
  GetterMethods as DiscountFeederUserMethods,
  GetDiscount as discountFeederGetDiscount,
} from './getters';

const NamedAdminMethods = {
  discountFeederSetDiscountForTier,
  discountFeederRemoveDiscount,
  discountFeederChangeOwner,
};
const NamedUserMethods = {
  discountFeederGetDiscount,
};

export const DiscountFeederMethods = {
  ...NamedAdminMethods,
  ...NamedUserMethods,
}
export {
  DiscountFeederAdminMethods,
  DiscountFeederUserMethods
};
export default DiscountFeederMethods;